<template>
	<div class="personAccount">
		<van-nav-bar
			class="nav_bar"
			title="账号安全"
			left-arrow
			placeholder
			@click-left="$router.back()"
		/>
		<ul class="content">
			<li class="item">
				<img
					class="item_icon"
					src="../../../assets/images/account/ic-dlmm@2x.png"
					alt=""
				/>
				<div class="right">
					<div class="r_title">登录密码</div>
					<div class="r_desc">
						建议您定期更换密码，设置安全性高的密码可以使帐号更安全
					</div>
					<div
						class="r_button borderOnePx"
						@click="handleSkip('/modifyPassword')"
					>
						修改密码
					</div>
				</div>
			</li>
			<li class="item">
				<img
					class="item_icon"
					src="../../../assets/images/account/ic-aqsj@2x.png"
					alt=""
				/>
				<div class="right">
					<div class="r_title">
						{{
							userphone
								? `安全手机 ${userphone}`
								: '当前还未绑定安全手机'
						}}
					</div>
					<div class="r_desc">
						安全手机可以用于登录帐号，重置密码或其他安全验证
					</div>
					<div
						class="r_button borderOnePx"
						@click="
							handleSkip(`/modifyPhone?userphone=${userphone}`)
						"
					>
						{{ userphone ? '更换' : '去绑定' }}
					</div>
				</div>
			</li>
			<li class="item">
				<img
					class="item_icon"
					src="../../../assets/images/account/ic-yx@2x.png"
					alt=""
				/>
				<div class="right">
					<div class="r_title">
						{{ usermail ? usermail : '当前还未绑定邮箱地址' }}
					</div>
					<div class="r_desc">
						绑定邮箱可以用于登录帐号，重置密码或其他安全验证
					</div>
					<div
						class="r_button borderOnePx"
						@click="handleSkip(`/modifyMail?usermail=${usermail}`)"
					>
						{{ usermail ? '更换' : '去绑定' }}
					</div>
				</div>
			</li>
		</ul>
	</div>
</template>

<script>
export default {
	name: 'personAccount',
	data() {
		return {
			userphone: '',
			usermail: '',
		}
	},
	mounted() {
		this.getCurrentUserAccount()
		this.getCurrentUserMail()
	},
	methods: {
		// 获取已绑定手机
		getCurrentUserAccount() {
			this.$api.usercenter.getCurrentUserAccount().then((res) => {
				if (res.data) {
					this.userphone = res.data
				}
			})
		},
		// 获取已绑定邮箱
		getCurrentUserMail() {
			this.$api.usercenter.getCurrentUserMail().then((res) => {
				if (res.data) {
					this.usermail = res.data
				}
			})
		},
		handleSkip(path) {
			this.$router.push(path)
		},
	},
}
</script>

<style lang="stylus" scoped>
.personAccount
    height 100%
    background #F5F6FA
    .nav_bar
        background #ffffff
    .content
        width 690px
        margin 0 auto
        margin-top 32px
        .item
            display flex
            margin-bottom 32px
            // height 157px
            border-radius 16px
            background #ffffff
            padding 58px 32px 32px 40px
            .item_icon
                width 88px
                height 88px
            .right
                display inline-block
                margin-left 24px
                .r_title
                    font-size 36px
                    font-family PingFangSC-Medium, PingFang SC
                    font-weight 500
                    color #333333
                    line-height 1
                .r_desc
                    margin 24px 0
                    font-size 24px
                    font-family PingFangSC-Regular, PingFang SC
                    color #999999
                    line-height 40px
                .r_button
                    width 176px
                    height 64px
                    float right
                    font-family PingFangSC-Regular, PingFang SC
                    text-align center
                    line-height 64px
                    font-size 28px
                    color #1972FF
                .borderOnePx
                    &:before
                        border 1PX solid #1972FF
                        border-radius 32PX
</style>
